import ReduxProvider from './redux';
import ThemesProvider from './theme';
import RouterProvider from './routes';
import ReactQueryProvider from './react-query';
import ModalProvider from './modals';
import { ProvidersProps } from './providers.types';

const AppProvider: React.FC<ProvidersProps> = ({ children }) => (
  <ReduxProvider>
    <ReactQueryProvider>
      <ThemesProvider>
        <RouterProvider>
          <ModalProvider />
          {children}
        </RouterProvider>
      </ThemesProvider>
    </ReactQueryProvider>
  </ReduxProvider>
);

export default AppProvider;
